/**
 * Estado de UI para proveedores de facturación electrónica.
 * "Conectado" solo si enabled + configured (credenciales/certs reales),
 * no por tener el feature flag del plan.
 */
import type { ProviderStatus } from "@/lib/provider-registry";

export type InvoicingConfigSnap = {
  enabled: boolean;
  configured: boolean;
  /** ARCA: homo|prod — TusFacturas: sandbox|production */
  environment?: string | null;
};

export function resolveInvoicingConnectionStatus(input: {
  flagEnabled: boolean;
  minPlan?: string;
  config: InvoicingConfigSnap | null | undefined;
}): ProviderStatus {
  if (!input.flagEnabled) {
    return input.minPlan ? "requires_plan" : "not_configured";
  }
  const cfg = input.config;
  if (!cfg?.configured) return "requires_credentials";
  if (!cfg.enabled) return "disabled";
  const env = (cfg.environment ?? "").toLowerCase();
  if (env === "homo" || env === "sandbox") return "sandbox";
  if (env === "prod" || env === "production") return "production";
  return "configured";
}

export function invoicingStatusApiPath(providerId: string): string | null {
  if (providerId === "arca_directo") return "/api/tenant/afip-direct";
  if (providerId === "tusfacturas") return "/api/tenant/invoicing";
  return null;
}
